import Vue from 'vue'
import VueRouter, {RouteConfig} from 'vue-router'
// Auth
import login from './auth/login'
// Pages
import airline from './airline/airline'
import configuration from './configuration/configuration'
import creditor from './creditor/creditor'
import debtor from './debtor/debtor'
import home from './pages/home'
import invoicesExpect from './invoices/expected'
import invoicesIncoming from './invoices/incoming'
import invoicesOutgoing from "./invoices/outgoing"
import invoicesManual from "./invoices/manual"
import notFound from './pages/404'
import {api} from '@sfs-projects/sfs-fc-api-sdk';
import pricelist from './pages/pricelist';
import DebtorDetails from './debtor/debtorDetails';
import DebtorAdd from './debtor/debtorAdd';
import DebtorEdit from './debtor/debtorEdit';
import CreditorDetails from './creditor/creditorDetails';
import CreditorAdd from './creditor/creditorAdd';
import CreditorEdit from './creditor/creditorEdit';
import InvoiceTemplate from './templates/invoice';
import debtorTracking from './debtorTracking/debtorTracking';
import environments from './configuration/environments';

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
    airline,
    configuration,
    creditor,
    debtor,
    debtorTracking,
    invoicesExpect,
    InvoiceTemplate,
    invoicesIncoming,
    invoicesOutgoing,
    invoicesManual,
    home,
    login,
    notFound,
    pricelist,
    DebtorAdd,
    DebtorDetails,
    DebtorEdit,
    CreditorAdd,
    CreditorDetails,
    CreditorEdit,
    environments,
    { path: '*', redirect: '/404' }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(async (to, from, next) => {
  const loggedIn = await api.Auth.isAuthenticated();
  if (to.path !== '/auth/login' && !loggedIn) {
    next('/auth/login')
    return
  }
  if (to.path === '/auth/login' && loggedIn) {
    next('/')
    return
  }
  next()
})

router.afterEach((to, from) => {
  Vue.nextTick(() => {
    document.title = to?.meta?.title ? to.meta.title : 'Home'
  })
})

export default router
